<template lang="pug">
  .module__main
    .module__title Список пользователей
    .module-content__container
      .users-control__block
        el-button.user-add__btn(type="primary" size="mini" @click="openUserAdding()") Добавить пользователя
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="formattedUsers"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(prop="name" label="Логин" width="160" sortable)
            el-table-column(prop="role" label="Роль" width="100" sortable)
              template(v-slot:default="scope")
                span {{ roles[scope.row.role] || scope.row.role }}
            el-table-column(label="Активен" width="100")
              template(v-slot:default="scope")
                .user-active-change__btn(
                  @click="changeUserActiveStatus(scope.row)"
                  :class="scope.row.active ? 'active' : 'inactive'"
                  )
                  i.el-icon-check(v-if="scope.row.active")
                  i.el-icon-close(v-else)
            el-table-column(label="Лимит выводов" width="200")
              template(v-slot:default="scope")
                .limit__container(v-if="scope.row.role === 'support'")
                  span {{ `${scope.row.withdraws_filled}/${scope.row.withdraws_limit}` }}
                  i.el-icon-refresh.limit__btn(@click="startResetSupportLimit(scope.row.id)")
                  i.el-icon-edit.limit__btn(@click="activateLimitChange(scope.row)")
            el-table-column(label="Аккаунты" width="400")
              template(v-slot:default="scope")
                .accounts__container(v-if="scope.row.role === 'support'")
                  .accounts__block
                    .accounts-block__title Доступные
                    .accounts__list
                      .account__container(v-for="account in scope.row.accounts_access")
                        .account__name {{ account.account }}
                        .access_container
                          i.el-icon-view.account__btn(:class="account.info ? 'color-success': 'color-danger'")
                          i.el-icon-upload2.account__btn.active(
                            :class="account.withdraws ? 'color-success': 'color-danger'"
                            @click="startEditUserAccountAccess(scope.row.id, account.account, 'withdraws', !account.withdraws)"
                            )
                          i.el-icon-delete.account__btn.color-danger.active(@click="startHandleUserAccounts(scope.row.id, account.account, 'delete')")
                  .accounts__block
                    .accounts-block__title Недоступные
                    .accounts__list
                      .account__container(v-for="account in scope.row.accountsToAdd")
                        .account__name {{ account }}
                        i.el-icon-plus.account__btn.color-success.active(@click="startHandleUserAccounts(scope.row.id, account, 'add')")
    el-dialog(:visible.sync="isUserAdding" :before-close="resetUserAdding" title="Добавление пользователя" width="50%")
      AddUser(v-if="isUserAdding" :roles="roles" @resetUserAdd="resetUserAdding" @updateUsers="loadUsersList")
    el-dialog(:visible.sync="isLimitChanging" :before-close="resetLimitChange" title="Изменение максимального лимита" width="30%")
      .balance-dialog__container
        .title Введите лимит
        el-input(type="number" v-model="limitChange.value" placeholder="Лимит")
        .user-add__buttons
          el-button(type="success" @click="changeUserLimit()") Изменить
          el-button(type="danger" @click="resetLimitChange()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  ADD_ACCOUNT_TO_USER,
  CREATE_USER, DELETE_ACCOUNT_FROM_USER, EDIT_SUPPORT_LIMIT,
  EDIT_USER, EDIT_USER_ACCOUNT_ACCESS,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT,
} from "../../store/const/user";
import AddUser from "./AddUser";
import instruments from '../../mixins/instruments';
import { LOAD_ACCOUNTS_NAMES } from "../../store/const/accounts";

export default {
  name: 'UsersList',
  components: {
    AddUser,
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      isUserAdding: false,
      isLimitChanging: false,
      limitChange: {
        user_id: null,
        user_name: '',
        value: 0,
      }
    }
  },
  mounted() {
    this.loadUsersList();
    this.loadAccountsNames();
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('user', [
      'users',
      'roles',
    ]),
    ...mapGetters('accounts', [
      'names',
    ]),
    isLoading() {
      return this.loading(LOAD_USERS_LIST) === 'loading';
    },
    isError() {
      return this.loading(LOAD_USERS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_USERS_LIST);
    },
    formattedUsers() {
      return this.users.map((user) => {
        return {
          ...user,
          accountsToAdd: this.names.filter((name) => !user.accounts_names.includes(name)),
        }
      })
    }
  },
  methods: {
    ...mapActions('user', {
      loadUsersList: LOAD_USERS_LIST,
      addNewUser: CREATE_USER,
      editUser: EDIT_USER,
      editLimit: EDIT_SUPPORT_LIMIT,
      resetLimit: RESET_SUPPORT_LIMIT,
      addAccountToUser: ADD_ACCOUNT_TO_USER,
      deleteAccountFromUser: DELETE_ACCOUNT_FROM_USER,
      editUserAccountAccess: EDIT_USER_ACCOUNT_ACCESS,
    }),
    ...mapActions('accounts', {
      loadAccountsNames: LOAD_ACCOUNTS_NAMES,
    }),
    openUserAdding() {
      this.isUserAdding = true;
    },
    resetUserAdding() {
      this.isUserAdding = false;
    },
    async changeUserActiveStatus(user) {
      this.$confirm(
          `Вы уверены, что хотите ${user.active ? 'деактивировать' : 'активировать'} пользователя?`,
          'Изменение пользователя'
      ).then(async () => {
        const request = await this.editUser({ id: user.id, data: { active: !user.active } });
        if (request.success) {
          this.$message.success('Пользователь успешно изменен');
          this.loadUsersList();
        } else {
          this.$message.error(`Ошибка изменения пользователя: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение пользователя отменено');
      });
    },
    activateLimitChange(user) {
      this.limitChange.user_id = user.id;
      this.limitChange.user_name = user.name;
      this.limitChange.value = user.withdraws_limit;
      this.isLimitChanging = true;
    },
    resetLimitChange() {
      this.limitChange = {
        user_id: null,
        user_name: '',
        value: 0,
      };
      this.isLimitChanging = false;
    },
    async changeUserLimit() {
      this.$confirm(
          `Вы уверены, что хотите изменить лимит пользователя?`,
          'Изменение пользователя'
      ).then(async () => {
        if (!this.limitChange.value) {
          this.$message.info(`Введите лимит`);
          return;
        } else if (this.limitChange.value < 0) {
          this.$message.info('Значение должно быть положительным');
          return;
        }
        const request = await this.editLimit({
          id: this.limitChange.user_id,
          data: {
            value: this.limitChange.value,
          }
        });
        if (request.success) {
          this.$message.success('Лимит успешно изменен');
          this.loadUsersList();
          this.resetLimitChange();
        } else {
          this.$message.error(`Ошибка изменения лимита: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение лимита отменено');
      });
    },
    async startResetSupportLimit(user_id) {
      this.$confirm(
          `Вы уверены, что хотите сбросить лимит пользователя?`,
          'Изменение пользователя'
      ).then(async () => {
        const request = await this.resetLimit({ id: user_id });
        if (request.success) {
          this.$message.success('Лимит успешно сброшен');
          this.loadUsersList();
        } else {
          this.$message.error(`Ошибка сброса лимита: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Сброс лимита отменен');
      });
    },
    async startHandleUserAccounts(id, account, mode) {
      this.$confirm(
          `Вы уверены, что хотите ${mode === 'add' ? 'добавить' : 'удалить'} аккаунт?`,
          'Изменение пользователя'
      ).then(async () => {
        const method = mode === 'add' ? this.addAccountToUser : this.deleteAccountFromUser;
        const request = await method({ id, account });
        if (request.success) {
          this.$message.success(`Аккаунт успешно ${mode === 'add' ? 'добавлен' : 'удален'}`);
          this.loadUsersList();
        } else {
          this.$message.error(`Ошибка изменения списка аккаунтов: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение списка аккаунтов отменено');
      });
    },
    async startEditUserAccountAccess(id, account, access_name, value) {
      this.$confirm(
          `Вы уверены, что хотите ${value === true ? 'разрешить' : 'запретить'} доступ?`,
          'Изменение пользователя'
      ).then(async () => {
        const request = await this.editUserAccountAccess({ id, account, [access_name]: value });
        if (request.success) {
          this.loadUsersList();
        } else {
          this.$message.error(`Ошибка изменения доступа к аккаунту: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение доступа к аккаунту отменено');
      });
    },
  }
};
</script>
<style scoped>
.users-control__block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.user-add__btn {
  width: 160px;
}

.limit__btn {
  margin-left: 5px;
  cursor: pointer;
  font-weight: bold;
}

.account__container {
  display: flex;
  justify-content: space-between;
}

.access_container {
  display: flex;
}

.account__btn {
  margin: 0 1px;
  padding: 2px;
  border: 1px solid;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.account__btn.active {
  cursor: pointer
}

.accounts__container {
  display: flex;
  justify-content: space-around;
}

.accounts__block {
  width: 180px;
  padding: 2px;
  border: 1px solid #e3e0e0
}

.accounts-block__title {
  font-weight: bold;
  text-align: center;
  margin: auto;
}

.accounts__list {
  height: 200px;
  overflow-y: scroll;
}
</style>
